import React, {FC, useRef} from 'react'
import {KTSVG} from '../../helpers'
import {useFormik} from 'formik'
import {ModalStatusInterface} from './types'
import {useStatusMessage} from '../../../app/features'
import {Post} from '../../../setup'
import {useForms, useNotifications} from '../../../app/@contexts'
import {Modal} from './Modal'

const UPDATE_STATUS = process.env.REACT_APP_WEB_FORMS_UPDATE_STATUS

const initialValues = {
    status: '0',
}

const UpdateStatusWebForm: FC<ModalStatusInterface> =
    ({status, id, textIcon, size}) => {

        const modalTarget = `edit_status_${id}`

        return (
            <>

                <Modal
                    button={{
                        bg: 'primary',
                        tooltip: 'Statut',
                        text: textIcon ? 'Statut' : undefined,
                        icon: {show: true, svg: 'art/art005'},
                    }}
                    modal={{
                        id: `${modalTarget}`,
                        size,
                        content: <Content id={id} status={status} />,
                    }}
                />
            </>
        )
    }

export {UpdateStatusWebForm}

const Content: FC<{id: string, status: string}> = ({id, status}) => {

    const {triggerReload, allStatus} = useForms()
    const {formState, setLoading} = useStatusMessage()
    const modalClose = useRef<HTMLButtonElement | null>(null)
    const endpoint = `${UPDATE_STATUS}/${id}`
    const {setToast} = useNotifications()

    const onSubmit = async (values: typeof initialValues, {setSubmitting}: {
        setSubmitting: (isSubmitting: boolean) => void
    }) => {

        setLoading(true)
        try {
            const {status, message} = await Post<any>(endpoint, values)
            setToast({type: 'success', text: {title: 'Status', message}})

            if (modalClose.current && status === 200) {
                triggerReload()
                setTimeout(() => {
                    modalClose.current?.click()
                }, 2600)
            }

        } catch (err) {
            console.error('Error submitting the form:', err)
        } finally {
            setLoading(false)
            setSubmitting(false)
        }
    }

    const formik = useFormik({
        initialValues: {status: status || '0'},
        enableReinitialize: true,
        onSubmit,
    })

    return (
        <form onSubmit={formik.handleSubmit}>
            <div className="modal-header">
                <h2>Status</h2>
                <div className="btn btn-sm btn-icon btn-active-color-primary"
                     data-bs-dismiss="modal">
                    <KTSVG path="/media/icons/duotune/arrows/arr061.svg" className="svg-icon-1" />
                </div>
            </div>
            <div className="modal-body p-3 p-sm-5 p-md-7">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="d-flex align-items-center">
                            <select className="form-select form-select-solid"
                                    id={`status_${id}`}
                                    {...formik.getFieldProps('status')}
                            >
                                {allStatus.map((status, index) => (
                                    <option value={status.id} key={index}>{status.name}</option>
                                ))}
                            </select>

                        </div>
                    </div>
                </div>
            </div>
            <div className="modal-footer">
                <button type="submit" className="btn btn-sm btn-primary me-2 px-6"
                        disabled={formState.loading}
                >
                    {formState.loading ? (
                        <span className="indicator-progress d-block">
                                                S'il vous plaît, attendez...
                                                <span className="spinner-border spinner-border-sm align-middle ms-2" />
                                            </span>
                    ) : (
                        'Sauvegarder'
                    )}
                </button>
                <button type="button"
                        className="btn btn-sm btn-primary me-2 px-6"
                        data-bs-dismiss="modal"
                        ref={modalClose}
                >
                    Fermer
                </button>
            </div>
        </form>
    )
}